/**
 * Show Options
 *
 * Hide additional options until any of the parental radio buttons has been clicked
 * (will show all if javascript is off)
 *
 * @since 1.0.0
 */

export default () => {
  const container = document.querySelector('.js-woo-options')
  if (!container) return
  if (container.dataset.default === 'yes') return
  const sizeContainer = container.querySelector('.js-woo-sizes')
  const dimensionsContainer = container.querySelector('.js-woo-dimensions')
  const defaultSizesContainer = container.querySelector('.js-woo-default-sizes')

  if (!sizeContainer || !dimensionsContainer || !defaultSizesContainer) return

  dimensionsContainer.classList.add('inactive')
  defaultSizesContainer.classList.add('inactive')
  const customButton = sizeContainer.querySelector('.js-woo-sizes-custom')
  const defaultButton = sizeContainer.querySelector('.js-woo-sizes-default')
  const customBack = dimensionsContainer.querySelector('.js-woo-back')
  const defaultBack = defaultSizesContainer.querySelector('.js-woo-back')
  const select = defaultSizesContainer.querySelector('.js-woo-default-select')

  customButton.addEventListener('click', e => {
    showOption(dimensionsContainer)
    hideOption(sizeContainer)
  })

  defaultButton.addEventListener('click', e => {
    showOption(defaultSizesContainer)
    hideOption(sizeContainer)
  })

  if (customBack) {
    customBack.addEventListener('click', e => {
      showOption(sizeContainer)
      hideOption(dimensionsContainer)
    })
  }

  if (defaultBack) {
    defaultBack.addEventListener('click', e => {
      showOption(sizeContainer)
      hideOption(defaultSizesContainer)
    })
  }

  if (select) {
    select.addEventListener('change', e => {
      const sizes = e.currentTarget.value.split('x')
      const width = sizes[1]
      const height = sizes[0]
      enterDefaultDimensions(container, width, height)
      select.disabled = true
    })
  }

  // if (input.value == 'standard') {
  //   // Enter default dimensions
  //   enterDefaultDimensions(container)
  // }
  // if (input.value == 'custom') {
  //   showCustomDimensions(container)
  // }
}

function enterDefaultDimensions(container, width, height) {
  const widthInput = container.querySelector('.js-woo-width')
  const lengthInput = container.querySelector('.js-woo-length')

  if (!widthInput || !lengthInput) return

  // Set to default dimensions
  widthInput.value = Number(width)
  lengthInput.value = Number(height)

  // Trigger events in order to trigger CalculatePrice
  widthInput.dispatchEvent(new Event('input', { bubbles: true }))
  lengthInput.dispatchEvent(new Event('input', { bubbles: true }))
}

function showOption(container) {
  if (container && container.classList.contains('inactive')) {
    container.classList.remove('inactive')
  }
}

function hideOption(container) {
  if (container) {
    container.classList.add('inactive')
  }
}



// WEBPACK FOOTER //
// ./src/js/woocommerce/ShowOptions.js